import React from 'react';
import { Breadcrumb } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../../Modules/InfratechMarketPlace/InfratechMarketplace.module.scss';
import { Icon } from '@iconify/react';

interface BreadcrumbItem {
    path: string;
    title: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
    const navigate = useNavigate()
    return (
        <Breadcrumb>
            <Breadcrumb.Item>
                <Icon
                    icon="ic:outline-home"
                    height="20"
                    onClick={() => navigate('/')}
                    style={{ margin: "auto", color: styles.strawberry, cursor: "pointer" }}
                />
            </Breadcrumb.Item>
            {items.map((item, index) => (
                <Breadcrumb.Item key={index}>
                    {item.path ?
                        <Link to={item.path}>{item.title}</Link>
                        :
                        <>
                            {item.title}
                        </>
                    }
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};

export default Breadcrumbs;
